import ObjectCache from './CacheService';
import LogicBaseCollectionApi from '../server/LogicBaseCollectionApi';
import UserAccount from '../UserAccount';
import LogicBaseCollection from '../../models/logicbasecollection';

class LogicBaseCollectionCache extends ObjectCache {
  api = LogicBaseCollectionApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseCollection(results._id, results.t, results.d, results.c, results.i, results.a, results.o, results.fr, results.e, results.ut, results.ss, results.fs, results.ce, results.at, results.pc, results.pw, results.error);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseCollectionCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
